$mol_icon_align_horizontal_right $mol_icon path \M20 2H22V22H20V2M2 10H18V7H2V10M8 17H18V14H8V17Z
